import React from 'react';
import Timetable from "./Timetable";

function TimetableAsSchedule(props) {
    return (
        <Timetable {...props} scheduleLayout={true} />
    );
}

export default TimetableAsSchedule;